export default "__VITE_ASSET__DbAwyZmc__"